module.exports = SPAUI;